<template>
    <article id="case-selector" 
        class="case-selector"
    >
        <header class="header">
            <span>個案查詢</span>
            <v-icon 
                @click="control_case_selector_dialog(false)"
                class="header__close-btn"
                color="white"
            >
                icon-close
            </v-icon>
        </header>
        <div class="case-selector__content">
            <div class="control">
                <v-autocomplete
                    label="個案類別"
                    :items="categories"
                    v-model="category_selected"
                />
                <v-menu
                    v-model="start_time_menu"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{ on }">
                        <v-text-field
                            v-model="model_start_time"
                            label="開始時間"
                            readonly
                            v-on="on"
                        >
                            <div class="v-input__icon v-input__icon--append" 
                                slot="append"
                            >
                                <v-icon color="black">
                                    icon-time-setting
                                </v-icon>
                            </div>
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="model_start_time">
                        <v-spacer />
                        <v-btn
                            text
                            color="primary"
                            @click="cancel_date_pick('start_time')"
                        >
                            {{ $t('__time_choose.cancel') }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="toggle_generate_time_durations('start_time')"
                        >
                            {{ $t('__time_choose.decide') }}
                        </v-btn>
                    </v-date-picker>
                </v-menu>
                <v-menu
                    v-model="end_time_menu"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{ on }">
                        <v-text-field
                            v-model="model_end_time"
                            label="結束時間"
                            readonly
                            v-on="on"
                        >
                            <div class="v-input__icon v-input__icon--append" 
                                slot="append"
                            >
                                <v-icon color="black">
                                    icon-time-setting
                                </v-icon>
                            </div>
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="model_end_time">
                        <v-spacer />
                        <v-btn
                            text
                            color="primary"
                            @click="cancel_date_pick('end_time')"
                        >
                            {{ $t('__time_choose.cancel') }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="toggle_generate_time_durations('end_time')"
                        >
                            {{ $t('__time_choose.decide') }}
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>
            <v-data-table
                :headers="headers"
                :items="cases"
                class="case-table"
            >
                <template #item.report_form="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="edit_report_form(item)"
                    >
                        edit
                    </v-icon>
                </template>
                <template #item.warning_form="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="edit_warn_form(item)"
                    >
                        edit
                    </v-icon>
                </template>
                <template #item.alert_form="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="edit_alert_form(item)"
                    >
                        edit
                    </v-icon>
                </template>
                <template #item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="choose_case(item)"
                    >
                        search
                    </v-icon>
                </template>
                <template #no-data>
                    <v-btn color="primary" 
                        @click="initialize"
                    >
                        重新整理
                    </v-btn>
                </template>
            </v-data-table>
        </div>            
        <v-dialog 
            v-model="dialog_form" 
            persistent 
            max-width="684px"
        >
            <header class="header">
                <span class="header__title">{{ form_name }}</span>
                <v-spacer />
                <v-icon 
                    class="header__close-btn"
                    color="white"
                    @click="dialog_form=false"
                >
                    icon-close
                </v-icon>
            </header>
            <v-data-table
                :headers="form_headers"
                :items="form_data"
                class="case-table"
            >
                <template #item.file_path="{ item }">
                    <v-btn 
                        x-small 
                        color="secondary" 
                        dark 
                        class="download-btn"
                    >
                        <a 
                            :href="CASE_FILE_URL + item.filepath"
                            title="download" 
                            target="_blank" 
                        >
                            Download
                        </a>
                    </v-btn>
                </template>
                <template #item.tra_file_path="{ item }">
                    <v-btn 
                        x-small 
                        color="secondary" 
                        dark 
                        class="download-btn"
                    >
                        <a 
                            :href="CASE_FILE_URL + item.filepath"
                            target="_blank" 
                            download
                        >
                            Download
                        </a>
                    </v-btn>
                </template>
            </v-data-table>
        </v-dialog>
    </article>
</template>
<script>
    import { mapState } from 'vuex'
    import { CASE_FILE_URL } from '../../config/case_config.js'
    import {
        get_case_by_year_obj_ajax,
        get_case_warn_list_ajax,
        get_case_report_list_ajax,
        get_case_alert_list_ajax,
    } from '@/utils/case/case_ajax.js';
    
    export default {
        name: 'CaseSelector',

        props: {
            init_year: {
                type: String,
                default () {
                    return ''
                }
            },
        },

        data() {
            return {
                CASE_FILE_URL: "",
                dialog_form: false,
                category_selected: 'ALL',
                categories: [
                    { text:"ALL", value:"ALL" },
                    { text:"颱風", value: "颱風" },
                    { text:"豪雨", value: "豪雨" },
                    { text:"其他", value: "其他"},
                ],
                start_time_menu: '',
                end_time_menu: '',

                // toISOString 會讓 new Date 時間 -8，剛好才能等於想要表達的一年第一天及一年最後一天
                start_time: new Date(this.init_year, 0, 2).toISOString().substr(0, 10),
                end_time: new Date(this.init_year, 11, 32).toISOString().substr(0, 10),
                model_start_time: new Date(this.init_year, 0, 2).toISOString().substr(0, 10),
                model_end_time: new Date(this.init_year, 11, 32).toISOString().substr(0, 10),
                
                default_headers: [
                    { text: 'sn', value: 'sn' },
                    { text: '個案名稱', value: 'case_name' },
                    { text: '類別', value: 'category' },
                    { text: '類別描述', value: 'detail_description' },
                    { text: '開始時間', value: 'start_time' },
                    { text: '結束時間', value: 'end_time' },
                    { text: '個案註記', value: 'case_comment' },
                    { text: '最後修改時間', value: 'last_modify_time' },
                    { text: '報告表', value: 'report_form', sortable: false },
                    { text: '警戒表', value: 'warning_form', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false },
                ],
                tra_headers: [
                    { text: 'sn', value: 'sn' },
                    { text: '個案名稱', value: 'case_name' },
                    { text: '類別', value: 'category' },
                    { text: '類別描述', value: 'detail_description' },
                    { text: '開始時間', value: 'start_time' },
                    { text: '結束時間', value: 'end_time' },
                    { text: '個案註記', value: 'case_comment' },
                    { text: '最後修改時間', value: 'last_modify_time' },
                    { text: '報告表', value: 'report_form', sortable: false },
                    { text: '警戒表', value: 'warning_form', sortable: false },
                    { text: '閃燈總表', value: 'alert_form', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false },
                ],
                cases: [],

                // 警示表表格
                form_name: "",
                form_headers: [],

                default_form_headers: [
                    { text: 'sn', value: 'sn' },
                    { text: '名稱', value: 'filename' },
                    { text: '最後修改時間', value: "last_modify_time"},
                    { text: '下載', value: 'file_path'},
                ],
                
                tra_form_headers: [
                    { text: '名稱', value: 'filename' },
                    { text: '最後修改時間', value: "last_modify_time"},
                    { text: '下載', value: 'tra_file_path'},
                ],
                form_data: [],
                tag_list: [],
                tag_name: null,
            }
        },

        computed: {
            ...mapState([
                'client_name'
            ]),

            initialize_condition() {
                return `${ this.category_selected } ${this.start_time} ${this.end_time}`
            },

            headers() {
                return this.client_name === 'TRA' ? this.tra_headers : this.default_headers
            }
        },

        watch: {
            init_year () {
                this.start_time = new Date(this.init_year, 0, 2).toISOString().substr(0, 10);
                this.end_time = new Date(this.init_year, 11, 32).toISOString().substr(0, 10);
                this.change_model_time()
            },

            initialize_condition () {
                this.initialize();
            },
        },

        created() {
            this.initialize();
            this.CASE_FILE_URL = CASE_FILE_URL;

            this.change_model_time()
        },
        
        methods: {
            async initialize () {
                const param = {
                    category: this.category_selected,
                    start_time: this.start_time,
                    end_time: this.end_time,
                    group_name: this.$store.getters.group_name
                };

                const res = await get_case_by_year_obj_ajax(param);
                this._reconstruct_case_list(res)
            },

            change_model_time() {
                this.model_end_time = this.end_time
                this.model_start_time = this.start_time
            },

            _reconstruct_case_list(res) {
                if (res['data']['status'] == 'success') {
                    const data = res['data']['data'];
                    this.cases = data || []
                }
            },

            control_case_selector_dialog(boolean_value) {
                this.$emit('control-case-selector-dialog', boolean_value);
            },

            edit_report_form(item) {
                this.dialog_form = true;
                this.form_name = `${item.case_name}報告表`;
                this.get_case_report_list(item.sn);
                this.form_headers = this.default_form_headers;
            },
            
            edit_warn_form(item) {
                this.dialog_form = true;
                this.form_name = `${item.case_name}警戒表`;
                this.get_case_warn_list(item.sn);
                this.form_headers = this.default_form_headers;
            },
            
            edit_alert_form(item) {
                this.dialog_form = true;
                this.form_name = `${item.case_name}閃燈總表`;
                this.get_case_alert_list(item.sn);
                this.form_headers = this.tra_form_headers;
            },
            
            async get_case_warn_list(sn) {
                try {
                    const res = await get_case_warn_list_ajax(sn);
                    this._reconstruct_case_form(res)
                } catch (error) {
                    console.error(error);
                }
            },

            async get_case_report_list(sn) {
                try {
                    const res = await get_case_report_list_ajax(sn);
                    this._reconstruct_case_form(res)
                } catch (error) {
                    console.error(error);
                }
            },
            
            async get_case_alert_list(sn) {
                try {
                    const res = await get_case_alert_list_ajax(sn);
                    this._reconstruct_case_form(res)
                } catch (error) {
                    console.error(error);
                }
            },

            _reconstruct_case_form(res) {
                if (!(res.data instanceof Object)) {
                    res.data = JSON.parse(res.data);
                }

                if (res['data']['status'] == 'success') {
                    const data = res['data']['data'];
                    const add_sn_data = data.map(datum => {
                        return {
                            ...datum, 
                            'sn': datum['alert_sn'] || datum['report_sn']
                        }
                    })
                    this.form_data = add_sn_data;

                }
            },

            cancel_date_pick(type) {
                this[`${type}_menu`] = false
                this[`model_${type}`] = this[type]

                // model_start_time: 
                // model_end_time:
            },

            toggle_generate_time_durations(type) {
                this[`${type}_menu`] = false
                this[type] = this[`model_${type}`]
            },

            choose_case(case_selected) {
                this.$emit('enter-case-mode', case_selected);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../css/mixin';

    .case-selector {
        position: relative;
        background-color: #fff;

        &__content {
            overflow-y: auto;
            padding: 1rem;
            max-height: calc(90vh - 3rem);
        }
    }

    .header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 3rem;
        font-size: 1.25rem;
        color: #fff;
        background-color: var(--base-dark-blue);

        &__title {
            margin: 0 .5rem;
        }

        &__close-btn {
            position: absolute;
            right: 0;
            padding: .75rem;
        }
    }

    .control {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;

        @include mobile {
            grid-template-columns: 1fr;
            gap: 0;
        }
    }

    .case-table {
        color: #000;
    }

    .download-btn a {
        text-decoration: none;
        color: #fff !important;
    }
</style>

<style scoped>
    .case-table >>> th {
        color: #000 !important;
        background: var(--monitor-header);
        border-right: 1px solid #fff;
    }

    .case-table >>> td:not(:last-child) {
        border-right: 1px solid var(--white-border);
    }
</style>